import { render, staticRenderFns } from "./app.scene.vue?vue&type=template&id=75a7aad2&scoped=true"
import script from "./app.scene.ts?vue&type=script&lang=ts&external"
export * from "./app.scene.ts?vue&type=script&lang=ts&external"
import style0 from "./app.scene.scss?vue&type=style&index=0&id=75a7aad2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a7aad2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VMain})
